import { theme as themeCore } from 'antd';

export const useTheme = () => {
	const theme = themeCore.useToken();
	return theme;
};
